import { render, staticRenderFns } from "./Mirror.vue?vue&type=template&id=6a782202&"
import script from "./Mirror.vue?vue&type=script&lang=ts&"
export * from "./Mirror.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports